import React from 'react';
import { X } from 'lucide-react';
import styles from '../StudyManagement.module.css';
import { MAX_SUBJECTS_PER_USER } from '../Contants';
// import { MAX_SUBJECTS_PER_USER } from '../constants';

const SubjectLimitModal = ({ show, onClose, userSubjectsCount }) => {
    if (!show) return null;

    return (
        <>
            <div className={styles.modalBackdrop} onClick={onClose}></div>
            <div className={styles.limitModal}>
                <div className={styles.modalHeader}>
                    <div className={styles.modalIcon}>
                        <div className={styles.errorIconCircle}>⚠️</div>
                    </div>
                    <button className={styles.modalCloseButton} onClick={onClose}>
                        <X size={20} />
                    </button>
                </div>
                <div className={styles.modalContent}>
                    <h2 className={styles.modalTitle}>Subject Creation Limit Reached</h2>
                    <p className={styles.modalMessage}>
                        You have reached the maximum limit of <strong>{MAX_SUBJECTS_PER_USER} subjects</strong>.
                    </p>
                    <p className={styles.modalSubMessage}>
                        You currently have <strong>{userSubjectsCount}</strong> subjects created.
                        Please contact your administrator if you need to create more subjects.
                    </p>
                </div>
                <div className={styles.modalFooter}>
                    <button className={styles.modalButton} onClick={onClose}>
                        I Understand
                    </button>
                </div>
            </div>
        </>
    );
};

export default SubjectLimitModal;